import { Injectable } from "@angular/core";
import { Http, Response, URLSearchParams, Headers } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { AdalHttp } from '../../services/adal.http.service';
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";

@Injectable()
export class CustomApplicationCreator {
    constructor(private http: AdalHttp) {
    }

    createCustomApplication(applicationName: string, userEmail: string, loginUrl: string, redirectUrl: string): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        var requestBody = {
            'ApplicationName': applicationName,
            'LoginUrl': loginUrl,
            'RedirectUrl': redirectUrl,
            'Email': userEmail
        };
        let productUrl: string = "/api/auth/application/";
        return this.http.post(productUrl, JSON.stringify(requestBody), {
            headers: headers
        })
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
    createCustomAdApplication(applicationName: string, userEmail: string, replyUrl: string): Observable<any> {
        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        var requestBody = {
            'ApplicationName': applicationName,
            'ReplyUrl': replyUrl,
            'Email': userEmail
        };
        let productUrl: string = "/api/custom/application/";
        return this.http.post(productUrl, JSON.stringify(requestBody), {
                headers: headers
            })
            .catch((error: any) => {
                console.log("Error"+error);
                return Observable.throw(error);
            });
    }

}



/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/customapplicationcreation/custom-application-creation.service.ts
 **/